import type { Profile } from '@/types';

/** The internal profiles that get their own three steps; buyers and operators get the buying tour. */
export type RoleTourProfile =
  | 'procurement'
  | 'commercial_backoffice'
  | 'controllership'
  | 'platform_admin';

export interface RoleTourStep {
  readonly title: string;
  readonly detail: string;
}

export const ROLE_TOUR_STEPS: Readonly<Record<RoleTourProfile, readonly RoleTourStep[]>> = {
  procurement: [
    {
      title: 'Cadastre o produto',
      detail: 'Código, descrição e unidade base. É o que todo o resto usa.',
    },
    {
      title: 'Registre o custo do fornecedor',
      detail: 'Por faixa de quantidade: comprando mais, o custo cai.',
    },
    {
      title: 'O comercial publica o preço',
      detail: 'Seu custo mais o spread vira o preço que o cliente vê.',
    },
  ],
  commercial_backoffice: [
    { title: 'Defina o spread', detail: 'Por categoria e, se precisar, por cliente.' },
    {
      title: 'Publique a tabela de preço',
      detail: 'Custo mais spread vira o preço de cada cliente.',
    },
    {
      title: 'Acompanhe entregas e contratos',
      detail: 'A fila de entregas e a posição de cada contrato.',
    },
  ],
  controllership: [
    {
      title: 'Acompanhe os pagamentos',
      detail: 'Pix e boleto passam a Pago quando o provedor confirma.',
    },
    {
      title: 'Concilie com o provedor',
      detail: 'O que difere fica sinalizado. Nada é corrigido sozinho.',
    },
    {
      title: 'Leia os indicadores',
      detail: 'GMV, pedidos, OTIF e mais, para o período que escolher.',
    },
  ],
  platform_admin: [
    { title: 'Vá a qualquer tela com ⌘K', detail: 'Digite parte do nome e aperte Enter.' },
    {
      title: 'Tudo organizado por área',
      detail: 'Cadastro, Preços, Contratos, Logística e Financeiro.',
    },
    { title: 'Acompanhe a operação', detail: 'Indicadores e a posição dos contratos.' },
  ],
};

export function isRoleTourProfile(profile: Profile | null): profile is RoleTourProfile {
  return profile !== null && profile in ROLE_TOUR_STEPS;
}
